var map = {
	"./btn-bj.png": "b702",
	"./camera.png": "c1ab",
	"./coin-dimd-bj.png": "9783",
	"./coin-dimd.png": "a837",
	"./coin-gct-bj-1.jpg": "6a4e",
	"./coin-gct-bj-2.png": "9498",
	"./coin-gct-bj-3.png": "a034",
	"./coin-gct-bj.jpg": "dad6",
	"./coin-gct.png": "c942",
	"./coin-rwa-bj-1.png": "72a1",
	"./coin-rwa-bj.jpg": "7130",
	"./coin-rwa.png": "5ba3",
	"./coin-top100-bj.png": "e6f0",
	"./coin-top100.png": "1e2b",
	"./download-app.png": "133a",
	"./footer-download.png": "d301",
	"./footer/1.png": "b6e6",
	"./footer/2 (2).png": "94c4",
	"./footer/2.png": "fe35",
	"./footer/3.png": "b901",
	"./footer/4.png": "8909",
	"./footer/5.png": "50d0",
	"./home-bj.png": "db7f",
	"./home-img1.png": "415b",
	"./home-img2.png": "f2da",
	"./home/eye.png": "8091",
	"./home/eye2.png": "f46e",
	"./home/film-bj.png": "8dc0",
	"./home/footer1.png": "28ab",
	"./home/footer2.png": "8d8d",
	"./home/footer3.png": "2532",
	"./home/footer4.png": "4c53",
	"./home/footer5.png": "2d89",
	"./home/group-11036.png": "dc76",
	"./home/group-11414.png": "cc28",
	"./home/group-11558.png": "2771",
	"./home/group-11562.png": "628f",
	"./home/group-11622.png": "453c",
	"./home/group-11623.png": "57ee",
	"./home/group-11624.png": "e1d6",
	"./home/group-11625.png": "746f",
	"./home/group-11630.png": "e14d",
	"./home/group-11631.png": "9818",
	"./home/group-11638.png": "cc5e",
	"./home/group-11642.png": "fd8e",
	"./home/group-5.png": "2ff9",
	"./home/group-8.png": "cdd9",
	"./home/head-bj.png": "ffde",
	"./home/head1-en.png": "eb4d",
	"./home/head1-zh.png": "fbe9",
	"./home/head2-en.png": "53d7",
	"./home/head2-zh.png": "c793",
	"./home/head3-en.png": "4d53",
	"./home/head3-zh.png": "847d",
	"./home/head4-en.png": "3ab2",
	"./home/head4-zh.png": "d2eb",
	"./home/introduction-en.png": "d01b",
	"./home/introduction-zh.png": "63de",
	"./home/logo-b.png": "0e8e",
	"./home/logo-h.png": "3303",
	"./home/logo.png": "d3d6",
	"./home/mask-group-1.png": "cc62",
	"./home/mask-group-2.png": "70bf",
	"./home/mask-group-3.png": "46fb",
	"./home/play.png": "7426",
	"./home/question.png": "064c",
	"./home/solutions1.png": "7d76",
	"./home/solutions2.png": "dee5",
	"./home/solutions3.png": "3d02",
	"./home/solutions4.png": "1546",
	"./home/solutions5.png": "52b6",
	"./home/solutions6.png": "b807",
	"./icon/android-icon-black.png": "b1f3",
	"./icon/android-icon.png": "0033",
	"./icon/arrow-down.png": "bf6b",
	"./icon/arrow-top.png": "18ac",
	"./icon/back-border.png": "ae7b",
	"./icon/close-icon.png": "1ab3",
	"./icon/coin-hk-icon.png": "e303",
	"./icon/coin-icon.png": "e442",
	"./icon/coin-r-icon.png": "96b6",
	"./icon/copy.png": "bd04",
	"./icon/eye1.png": "bec3",
	"./icon/eye2.png": "bc4b",
	"./icon/icon-question.png": "5d29",
	"./icon/icon-tab1-s.png": "d8b3",
	"./icon/icon-tab1.png": "edac",
	"./icon/icon-tab2-s.png": "7387",
	"./icon/icon-tab2.png": "947a",
	"./icon/icon-tab3-s.png": "a38a",
	"./icon/icon-tab3.png": "04da",
	"./icon/ios-icon-balck.png": "9391",
	"./icon/ios-icon.png": "b154",
	"./icon/more-icon.png": "5876",
	"./icon/more-s-icon.png": "a636",
	"./icon/r-icon.png": "d938",
	"./icon/star-blue.png": "7ece",
	"./icon/star.png": "9082",
	"./icon/success-icon.png": "aab1",
	"./icon/upload-img.png": "ee84",
	"./icon/user-s.png": "1c02",
	"./icon/user.png": "3f07",
	"./icon/wallet-hot.png": "58f8",
	"./icon/wallet-icon-all-s.png": "76d8",
	"./icon/wallet-icon-all.png": "00da",
	"./icon/wallet-icon1-s.png": "1195",
	"./icon/wallet-icon1.png": "25b1",
	"./icon/wallet-icon2-s.png": "3503",
	"./icon/wallet-icon2.png": "17f6",
	"./icon/warning-icon.png": "adef",
	"./icon/zuanshi-icon.png": "6b35",
	"./login-bj.png": "18b6",
	"./logo-black.png": "a622",
	"./logo-white.png": "f135",
	"./mall-item.png": "1d0c",
	"./mall-jietu.png": "bf85",
	"./mall-list-nodata.png": "b790",
	"./member-bj.png": "dc54",
	"./nav/download-s.png": "ffdd",
	"./nav/download.png": "1bf1",
	"./nav/netword.png": "1f07",
	"./nav/network-s.png": "0a7d",
	"./nav/news-s.png": "b365",
	"./nav/news.png": "d435",
	"./nav/wallet-s.png": "13bb",
	"./nav/wallet.png": "7a96",
	"./news-bj.png": "7b96",
	"./news-item.png": "c612",
	"./news-nodata.png": "ddef",
	"./no-data-yh.png": "91bf",
	"./no-data.png": "9955",
	"./partner-program-bj.png": "b757",
	"./qr-code-black.png": "d11d",
	"./qr-code.png": "3c8d",
	"./qrcode-black.png": "b43d",
	"./question-bj.png": "5ca0",
	"./question-black.png": "479c",
	"./user/1.png": "9af9",
	"./user/2.png": "0dc9",
	"./user/3.png": "5ded",
	"./user/4.png": "43c7",
	"./user/5.png": "dfcf",
	"./user/6.png": "5dbc5",
	"./user/7.png": "fc0a",
	"./user/8.png": "e45d",
	"./user/9.png": "8d3c",
	"./user/left1-s.png": "4f56",
	"./user/left1.png": "c451",
	"./user/left2-s.png": "592a",
	"./user/left2.png": "a2fd",
	"./user/left3-s.png": "7ced",
	"./user/left3.png": "51479",
	"./user/left4-s.png": "1867",
	"./user/left4.png": "1011",
	"./user/left5-s.png": "7349",
	"./user/left5.png": "3b95",
	"./user1.png": "a56a",
	"./user2.png": "3087",
	"./wallet1-bj.png": "e6a3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bec";